import * as React from 'react'
import styled, { css } from 'styled-components'

import TncModalLink from '../../../../components/home/TncModalLink/TncModalLink'
import Icon from '../../../../components/ui/Icon/Icon'

import * as MallApiService from '../../../../services/api/requests/Mall'
import { MAIN, FAQ_PAGE } from '../../../../services/data/profilePages.json'

import RightSideBarHeader from '../../../../assets/img/right-sidebar-header.svg'
import MoreHeaderParticles from '../../../../assets/img/more-header-particles.svg'

const PageBody = styled.div`
  position: relative;
  z-index: 0;
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: auto;

  &::before {
    content: ' ';
    position: absolute;
    display: block;
    height: 340px;
    width: 100%;
    background-color: var(--color-primary);
    background: url('${RightSideBarHeader}'), url('${MoreHeaderParticles}'), linear-gradient(var(--color-primary), var(--color-primary));
    background-position: bottom, center;
    background-repeat: no-repeat, repeat;
    background-size: 100%, auto;
    z-index: -1;
  }
`

const PageHeader = styled.div`
  height: 340px;
  padding: 1.5rem;
  color: #ffffff;
  flex: 0 0 auto;
`

const Title = styled.h1`
  font-size: 1.75rem;
  text-transform: uppercase;
  font-weight: var(--font-weight-boldest);
  text-align: center;
`

const Subtitle = styled.h3`
  font-size: 0.875rem;
  text-align: center;
  margin-top: 1.125rem;
`

const CloseButton = styled.div`
  color: #ffffff;
  background: rgba(255, 255, 255, 0.5);
  border-radius: 100%;
  width: 2rem;
  height: 2rem;

  display: flex;
  justify-content: center;
  align-items: center;

  cursor: pointer;
`

const StyledIcon = styled(Icon)`
  font-size: 1.5rem;
`

const PageContent = styled.div`
  flex: 1;
  padding: 1.5rem;
  background: #ffffff;
`

const ContentTitle = styled.h5`
  font-size: 0.75rem;
  margin: 0;
  text-transform: uppercase;
  color: var(--color-primary);
`

const ContentList = styled.ul`
  padding-left: 0;
  font-size: 0.875rem;
  list-style-position: inside;

  margin-bottom: 3rem;

  ${props =>
    props.columns &&
    css`
      columns: ${props.columns};
    `}

  &:last-child {
    margin-bottom: initial;
  }
`

const ContentItem = styled.li`
  margin-bottom: 1.375rem;

  &:last-child {
    margin: 0;
  }
`

const StyledLink = styled.a`
  cursor: pointer;
  color: var(--color-primary);
  text-decoration: none;
  font-weight: var(--font-weight-bold);
`

const StyledTncModalLink = styled(TncModalLink)`
  color: var(--color-primary);
  font-weight: var(--font-weight-bold);
`

const Highlight = styled.span`
  color: var(--color-primary);
  font-weight: var(--font-weight-bold);
`

function PointsMechanics(props) {
  const { setProfileModalPage } = props
  const [malls, setMalls] = React.useState([])

  React.useEffect(() => {
    MallApiService.getAllMalls().then(response => {
      setMalls(response.data)
    })
  }, [])

  return (
    <PageBody>
      <PageHeader>
        <CloseButton onClick={() => setProfileModalPage(MAIN)}>
          <StyledIcon name="slide-left" />
        </CloseButton>
        <Title>Earn Zing Points</Title>
        <Subtitle>
          Get access to exclusive perks
          <br />
          and earn amazing rewards!
        </Subtitle>
      </PageHeader>
      <PageContent>
        <ContentTitle>Mechanics</ContentTitle>
        <ContentList>
          <ContentItem>Open to all Zing Plus Members</ContentItem>
          <ContentItem>
            Start earning points with a minimum purchase of{' '}
            <Highlight>P200</Highlight> in participating merchants (look for the
            Zing decals in-store)
          </ContentItem>
          <ContentItem>
            <Highlight>P200 = 1</Highlight> point, except during special
            promotions where points may be higher
          </ContentItem>
          <ContentItem>
            A maximum of 500 Zing Points will be awarded per transaction
          </ContentItem>
          <ContentItem>
            Points earned this year will expire on December 31 of the following
            year
          </ContentItem>
          <ContentItem>
            For more details, visit our{' '}
            <StyledTncModalLink zIndex={10021}>
              Terms & Conditions
            </StyledTncModalLink>{' '}
            and{' '}
            <StyledLink onClick={() => setProfileModalPage(FAQ_PAGE)}>
              FAQs
            </StyledLink>
          </ContentItem>
        </ContentList>
        <ContentTitle>Participating Ayala Malls</ContentTitle>
        <ContentList>
          {malls
            .filter(mall => mall.loyalty)
            .map(mall => (
              <ContentItem>{mall.name}</ContentItem>
            ))}
        </ContentList>
      </PageContent>
    </PageBody>
  )
}

PointsMechanics.defaultProps = {
  // TODO: specify default props
}

PointsMechanics.propTypes = {
  // TODO: specify prop types
}

export default PointsMechanics
